(() => {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const lerp = (start, end, progress) => start + (end - start) * progress;

  const initScrollImageExpand = (root) => {
    if (!root || root.dataset.scrollImageExpandReady === 'true') return;

    const desktopMedia = root.querySelector('[data-expand-media="desktop"]');
    const mobileMedia = root.querySelector('[data-expand-media="mobile"]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopQuery = window.matchMedia('(min-width: 750px)');
    let ticking = false;

    root.dataset.scrollImageExpandReady = 'true';

    const getActiveMedia = () => (desktopQuery.matches ? desktopMedia : mobileMedia);

    const getTargetSize = (media, isDesktop) => {
      const sideInset = isDesktop ? 128 : 32;
      const maxHeightRatio = isDesktop ? 0.82 : 0.76;
      const availableWidth = Math.max(1, window.innerWidth - sideInset);
      const image = media.querySelector('img');
      const ratio = image?.naturalWidth && image?.naturalHeight ? image.naturalWidth / image.naturalHeight : 16 / 9;
      const maxHeight = window.innerHeight * maxHeightRatio;
      const targetWidth = Math.min(availableWidth, maxHeight * ratio);
      const targetHeight = targetWidth / Math.max(0.1, ratio);

      return { width: targetWidth, height: targetHeight, ratio };
    };

    const update = () => {
      ticking = false;
      const media = getActiveMedia();
      if (!media) return;

      const isDesktop = desktopQuery.matches;
      const startWidthPercent = parseFloat(root.dataset[isDesktop ? 'startWidthDesktop' : 'startWidthMobile'] || (isDesktop ? '24' : '62'));
      const startHeightPercent = parseFloat(root.dataset[isDesktop ? 'startHeightDesktop' : 'startHeightMobile'] || (isDesktop ? '28' : '46'));
      const scrollDistanceVh = parseFloat(root.dataset[isDesktop ? 'scrollDistanceDesktop' : 'scrollDistanceMobile'] || (isDesktop ? '44' : '34'));
      const startRadius = parseFloat(root.dataset.startRadius || '15');
      const startWidth = window.innerWidth * (startWidthPercent / 100);
      const startHeight = window.innerHeight * (startHeightPercent / 100);
      const target = getTargetSize(media, isDesktop);
      const finalHeight = Math.max(startHeight, target.height);
      const scrollDistance = Math.max(120, window.innerHeight * (scrollDistanceVh / 100));

      root.style.setProperty('--pedrocchi-expand-final-height', `${finalHeight.toFixed(2)}px`);
      root.style.setProperty('--pedrocchi-expand-scroll-distance', `${scrollDistance.toFixed(2)}px`);
      root.style.setProperty('--pedrocchi-expand-media-ratio', `${target.ratio}`);

      if (reducedMotion.matches) {
        media.style.width = `${target.width}px`;
        media.style.height = `${finalHeight}px`;
        media.style.borderRadius = '8px';
        return;
      }

      const rect = root.getBoundingClientRect();
      const rawProgress = clamp(-rect.top / scrollDistance);
      const progress = rawProgress * rawProgress * (3 - 2 * rawProgress);

      media.style.width = `${lerp(startWidth, target.width, progress).toFixed(2)}px`;
      media.style.height = `${lerp(startHeight, finalHeight, progress).toFixed(2)}px`;
      media.style.borderRadius = `${lerp(startRadius, 8, progress).toFixed(2)}px`;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    root.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', requestUpdate, { once: true });
    });
    if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', requestUpdate);

    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-scroll-image-expand]').forEach(initScrollImageExpand);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
